import Datalayer from './data/Datalayer'
import AnalyticsProvider from './provider/AnalyticsProvider'
import Status from './status/Status'

interface IAnalyticsProvider {
  new (...args: any[]): AnalyticsProvider
}

export default class Analytics {
  providers: AnalyticsProvider[] = []

  isInitalized = false

  async initialize(providers: AnalyticsProvider[]): Promise<Status[]> {
    const collection = []
    for (const provider of providers) {
      collection.push(provider.init())
      this.providers.push(provider)
    }

    this.isInitalized = true

    return Promise.all(collection)
  }

  async sendEvent(data: Datalayer, providers?: IAnalyticsProvider[]): Promise<Status[]> {
    const collection = []

    for (const provider of this.providers) {
      if (!providers) {
        if (provider.isActive) {
          collection.push(provider.sendEvent(data))
        }
      } else {
        for (const pr of providers) {
          if (pr.name === provider.constructor.name) {
            collection.push(provider.sendEvent(data))
          }
        }
      }
    }

    return Promise.all(collection)
  }
}
